import React, {useState} from "react";
import {Alert, Button, Form, Input} from "antd";
import SessionService from "../../services/SessionService";
import Credentials from "../../types/Credentials";
import Logo from "../apps/Logo";
import styles from "./LoginScreen.module.css";

export default function LoginScreen() {
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string>();

    const onFinish = (credentials: Credentials) => {
        setSubmitting(true);
        setError(undefined);
        SessionService.create(credentials)
            .catch((e: Error) => setError(e.message))
            .finally(() => setSubmitting(false));
    };

    return (
        <main className={styles.screen}>
            <div className={styles.card}>
                <Logo className={styles.logo}/>
                <h1 className={styles.heading}>Sign in to App Repo</h1>
                <p className={styles.lede}>Company apps for Android, Windows, macOS and Linux.</p>

                {error && (
                    <Alert type="error" title={error} showIcon className={styles.error} role="alert"/>
                )}

                <Form<Credentials>
                    layout="vertical"
                    requiredMark={false}
                    onFinish={onFinish}
                    disabled={submitting}
                    size="large"
                    className={styles.form}
                >
                    <Form.Item
                        name="username"
                        label="Username"
                        rules={[{required: true, message: "Enter your username"}]}
                    >
                        <Input autoComplete="username" autoFocus/>
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[{required: true, message: "Enter your password"}]}
                    >
                        <Input.Password autoComplete="current-password"/>
                    </Form.Item>
                    <Button type="primary" htmlType="submit" block loading={submitting} className={styles.submit}>
                        Continue
                    </Button>
                </Form>
            </div>
            <p className={styles.help}>Forgot your password or need an account? Ask the release team.</p>
        </main>
    );
}
